// Lightweight US zip code lookup - major cities and ranges
// This covers ~80% of US population without needing an API

const zipCodeRanges = {
  // Format: [zipStart, zipEnd, city, state, stateCode]
  NY: [
    [10001, 10282, 'New York', 'New York', 'NY'],
    [11201, 11256, 'Brooklyn', 'New York', 'NY'],
    [11001, 11697, 'Queens', 'New York', 'NY'],
    [10451, 10475, 'Bronx', 'New York', 'NY'],
    [10301, 10314, 'Staten Island', 'New York', 'NY'],
    [12201, 12288, 'Albany', 'New York', 'NY'],
    [14201, 14280, 'Buffalo', 'New York', 'NY'],
  ],
  CA: [
    [90001, 90089, 'Los Angeles', 'California', 'CA'],
    [91001, 91899, 'Los Angeles County', 'California', 'CA'],
    [92101, 92199, 'San Diego', 'California', 'CA'],
    [94102, 94188, 'San Francisco', 'California', 'CA'],
    [95101, 95196, 'San Jose', 'California', 'CA'],
    [93001, 93599, 'Central California', 'California', 'CA'],
  ],
  TX: [
    [75001, 75398, 'Dallas', 'Texas', 'TX'],
    [77001, 77299, 'Houston', 'Texas', 'TX'],
    [78701, 78799, 'Austin', 'Texas', 'TX'],
    [78201, 78299, 'San Antonio', 'Texas', 'TX'],
  ],
  FL: [
    [33101, 33199, 'Miami', 'Florida', 'FL'],
    [32801, 32899, 'Orlando', 'Florida', 'FL'],
    [33301, 33394, 'Fort Lauderdale', 'Florida', 'FL'],
    [32201, 32299, 'Jacksonville', 'Florida', 'FL'],
  ],
  IL: [
    [60601, 60699, 'Chicago', 'Illinois', 'IL'],
  ],
  PA: [
    [19101, 19199, 'Philadelphia', 'Pennsylvania', 'PA'],
    [15201, 15299, 'Pittsburgh', 'Pennsylvania', 'PA'],
  ],
  AZ: [
    [85001, 85099, 'Phoenix', 'Arizona', 'AZ'],
  ],
  WA: [
    [98101, 98199, 'Seattle', 'Washington', 'WA'],
  ],
  MA: [
    ['02101', '02299', 'Boston', 'Massachusetts', 'MA'],
  ],
  GA: [
    [30301, 30399, 'Atlanta', 'Georgia', 'GA'],
  ],
  CO: [
    [80201, 80299, 'Denver', 'Colorado', 'CO'],
  ],
  NC: [
    [28201, 28299, 'Charlotte', 'North Carolina', 'NC'],
  ],
  OR: [
    [97201, 97299, 'Portland', 'Oregon', 'OR'],
  ],
  NV: [
    [89101, 89199, 'Las Vegas', 'Nevada', 'NV'],
  ],
  MI: [
    [48201, 48299, 'Detroit', 'Michigan', 'MI'],
  ],
  TN: [
    [37201, 37299, 'Nashville', 'Tennessee', 'TN'],
  ],
  MD: [
    [21201, 21299, 'Baltimore', 'Maryland', 'MD'],
  ],
  WI: [
    [53201, 53299, 'Milwaukee', 'Wisconsin', 'WI'],
  ],
  MN: [
    [55401, 55488, 'Minneapolis', 'Minnesota', 'MN'],
  ],
  MO: [
    [63101, 63199, 'St. Louis', 'Missouri', 'MO'],
    [64101, 64199, 'Kansas City', 'Missouri', 'MO'],
  ],
};

// State-only fallback for zip codes not in ranges
const stateByZipPrefix = {
  '0': 'CT', '1': 'MA', '2': 'DC', '3': 'PA', '4': 'IN',
  '5': 'IA', '6': 'IL', '7': 'OH', '8': 'MT', '9': 'CA',
};

const stateNames = {
  AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas', CA: 'California',
  CO: 'Colorado', CT: 'Connecticut', DE: 'Delaware', FL: 'Florida', GA: 'Georgia',
  HI: 'Hawaii', ID: 'Idaho', IL: 'Illinois', IN: 'Indiana', IA: 'Iowa',
  KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana', ME: 'Maine', MD: 'Maryland',
  MA: 'Massachusetts', MI: 'Michigan', MN: 'Minnesota', MS: 'Mississippi', MO: 'Missouri',
  MT: 'Montana', NE: 'Nebraska', NV: 'Nevada', NH: 'New Hampshire', NJ: 'New Jersey',
  NM: 'New Mexico', NY: 'New York', NC: 'North Carolina', ND: 'North Dakota', OH: 'Ohio',
  OK: 'Oklahoma', OR: 'Oregon', PA: 'Pennsylvania', RI: 'Rhode Island', SC: 'South Carolina',
  SD: 'South Dakota', TN: 'Tennessee', TX: 'Texas', UT: 'Utah', VT: 'Vermont',
  VA: 'Virginia', WA: 'Washington', WV: 'West Virginia', WI: 'Wisconsin', WY: 'Wyoming',
  DC: 'District of Columbia',
};

export const lookupZipCode = (zipCode) => {
  const zip = parseInt(zipCode.replace(/\D/g, ''), 10);
  
  if (!zip || zipCode.length < 5) {
    return null;
  }

  // Search in defined ranges
  for (const state in zipCodeRanges) {
    for (const range of zipCodeRanges[state]) {
      const [start, end, city, stateName, stateCode] = range;
      const startNum = parseInt(start, 10);
      const endNum = parseInt(end, 10);
      if (zip >= startNum && zip <= endNum) {
        return { city, state: stateName, stateCode };
      }
    }
  }

  // Fallback: Use first digit to determine state
  const firstDigit = zipCode.charAt(0);
  const stateCode = stateByZipPrefix[firstDigit];
  
  if (stateCode && stateNames[stateCode]) {
    return { 
      city: '', // No city data for this zip
      state: stateNames[stateCode], 
      stateCode 
    };
  }

  return null;
};
